import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';
import { useTranslation } from 'react-i18next';
import { Table, TableContainer, Paper } from '@mui/material';
import FinancialProductPropertiesTableHead from './FinancialProductPropertiesTableHead';
import FinancialProductPropertiesTableBody from './FinancialProductPropertiesTableBody';
import { get } from '@totalsoft/change-tracking-react';

const FinancialProductPropertiesTable = ({
  canWrite,
  isNewFinancialProduct,
  onAdd,
  onCancelEdit,
  onDelete,
  onSave,
  properties,
  propertiesData,
  validation
}) => {
  const [t] = useTranslation();

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <FinancialProductPropertiesTableHead canWrite={canWrite} isNewFinancialProduct={isNewFinancialProduct} onAdd={onAdd} />
          {isNewFinancialProduct && (
            <FinancialProductPropertiesTableBody
              canWrite={canWrite}
              properties={properties}
              propertiesData={propertiesData}
              onCancelEdit={onCancelEdit}
              onDelete={onDelete}
              onSave={onSave}
              validation={validation}
            />
          )}
        </Table>
      </TableContainer>
      {!isNewFinancialProduct && <Placeholder message={t('FinancialProduct.Details.PleaseCompleteGeneralData')} color={'warning'} />}
      {isNewFinancialProduct && (properties?.length |> get) === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductPropertiesTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  isNewFinancialProduct: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  properties: PropTypes.array.isRequired,
  propertiesData: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default FinancialProductPropertiesTable;
